export enum PROFILE_TYPE {
  ADMINISTRATOR = 1,
  DIRECTOR = 2,
  COORDINATOR = 5,
  ASSISTANT = 6,
  TEACHER = 7,
  PRECEPTOR = 8,
  STUDENT = 9,
  SUPPORT = 10,
  ADMINISTRATIVE = 11,
}

export function getProfileKey(profileType: PROFILE_TYPE): string {
  switch (profileType) {
    case PROFILE_TYPE.COORDINATOR:
      return 'coordinators';
    case PROFILE_TYPE.TEACHER:
      return 'teachers';
    case PROFILE_TYPE.PRECEPTOR:
      return 'preceptors';
    case PROFILE_TYPE.ASSISTANT:
      return 'assistants';
    case PROFILE_TYPE.STUDENT:
      return 'students';
    case PROFILE_TYPE.SUPPORT:
      return 'support';
    case PROFILE_TYPE.ADMINISTRATIVE:
      return 'auxiliaries';
    case PROFILE_TYPE.ADMINISTRATOR:
      return 'administrators';
    case PROFILE_TYPE.DIRECTOR:
      return 'directors';
    default:
      return '';
  }
}
export function getProfileNameFromProfileType(
  profileType: PROFILE_TYPE,
): string {
  switch (profileType) {
    case PROFILE_TYPE.COORDINATOR:
      return 'coordenadores';
    case PROFILE_TYPE.TEACHER:
      return 'professores';
    case PROFILE_TYPE.PRECEPTOR:
      return 'preceptores';
    case PROFILE_TYPE.ASSISTANT:
      return 'assistentes';
    case PROFILE_TYPE.STUDENT:
      return 'estudantes';
    case PROFILE_TYPE.SUPPORT:
      return 'support';
    case PROFILE_TYPE.ADMINISTRATIVE:
      return 'auxiliares';
    case PROFILE_TYPE.ADMINISTRATOR:
      return 'administradores';
    case PROFILE_TYPE.DIRECTOR:
      return 'diretores';
    default:
      return '';
  }
}

export function getProfileTypeFromName(profileName: string): PROFILE_TYPE {
  switch (profileName) {
    case 'coordenadores':
      return PROFILE_TYPE.COORDINATOR;
    case 'professores':
      return PROFILE_TYPE.TEACHER;
    case 'preceptores':
      return PROFILE_TYPE.PRECEPTOR;
    case 'assistentes':
      return PROFILE_TYPE.ASSISTANT;
    case 'estudantes':
      return PROFILE_TYPE.STUDENT;
    case 'suportes':
      return PROFILE_TYPE.SUPPORT;
    case 'auxiliares':
      return PROFILE_TYPE.ADMINISTRATIVE;
    case 'administradores':
      return PROFILE_TYPE.ADMINISTRATOR;
    case 'diretores':
      return PROFILE_TYPE.DIRECTOR;
    default:
      throw new Error(`Unknown profile name: ${profileName}`);
  }
}
